import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { InvitationService } from 'src/app/services/invitation.service';
import { PermissionService } from 'src/app/services/permission.service';
import { PlacesService } from 'src/app/services/places.service';
import { NewManagerComponent } from '../new-manager/new-manager.component';
import { SelectPlacesManagerComponent } from '../select-places-manager/select-places-manager.component';
import { AppSettings } from 'src/app/app-settings';

@Component({
  selector: 'app-permission-panel',
  templateUrl: './permission-panel.component.html',
  styleUrls: ['./permission-panel.component.scss']
})
export class PermissionPanelComponent implements OnInit {

  @Input() roleActive!: any;
  searchText!: string;
  private searchTerms = new Subject<string>();
  now: any = new Date();

  //images base path
  urlImages: string = AppSettings.MEDIA_URI;

  loadingTable: boolean = true;
  loadingPage: boolean = true;
  finishScroll: boolean = false;
  loadingScroll: boolean = false;

  usersManager!: any[];

  displayedColumns: string[] = ['options', 'email', 'nombre', 'role', 'place'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();

  @ViewChild(MatSort) sort: MatSort = new MatSort;
  sorted!: any;

  page = 1;
  totalPages = 1;
  @ViewChild('containerScroll', { static: false }) containerScroll: ElementRef;

  // Obtener compaía
  business: any = JSON.parse(localStorage.getItem('business') || '{}');
  places = JSON.parse(localStorage.getItem('places') || '[]');
  idCompany: any = this.business?.id;

  // Select list
  @Input() activeSelectList: boolean = false;
  allSelected: boolean = false;
  selectedItems: any[] = [];
  profile = this.auth.getProfile();
  rolesProfile: any[] = [];
  admin: boolean = false;

  placesEnabled: any[];

  constructor(private permissionService: PermissionService, private router: Router, private activatedRoute: ActivatedRoute, private dialog: MatDialog,
    private invitationService: InvitationService, private auth: AuthenticationService, private placeService: PlacesService) { }

  ngOnInit(): void {
    this.rolesProfile = this.profile?.roles.map((role: any) => role.name);
    this.admin = this.rolesProfile.includes('admin') || this.rolesProfile.includes('superadmin');
    this.placeService.getPlacesByCompany(this.idCompany).subscribe({
      next: (res: any) => {
        this.placesEnabled = res;
      }
    });
  }

  openNewUser(object?: any) {
    const dialogRef = this.dialog.open(NewManagerComponent, {
      panelClass: ['info-dialog', 'not-padding'],
      disableClose: true,
      width: '750px',
      data: {
        idCompany: this.idCompany,
        object: object,
        send: this.placesEnabled?.length <= 0
      }
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res && res.user && res.functions) {
        if (!this.placesEnabled || this.placesEnabled.length <= 0) {
          this.sendInvite(res, { spaces: [], allSpaces: true });
        } else {
          this.openSelectPlace(res);
        }
      }
    });
  }

  openSelectPlace(object: any) {
    const dialogRef = this.dialog.open(SelectPlacesManagerComponent, {
      panelClass: ['info-dialog', 'not-padding'],
      width: '750px',
      maxWidth: '95vw',
      maxHeight: '95vh',
      disableClose: true,
      data: {
        idCompany: this.idCompany,
      }
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res && res.back) {
        this.openNewUser(object);
      }
      if (res && res.places) {
        this.sendInvite(object, res);
      }
    });
  }

  sendInvite(object: any, placeRes: any) {
    // Soportar ambas estructuras: 'spaces' y 'places'
    const selectedSpaces = placeRes.spaces || placeRes.places;

    // Validar que haya espacios seleccionados
    if (this.placesEnabled?.length > 0 && (!selectedSpaces || selectedSpaces.length === 0)) {
      this.openInfoCard('Debe seleccionar al menos un espacio para enviar la invitación');
      return;
    }

    const payload = {
      name: object.user.name,
      lastname: object.user.lastname,
      email: object.user.email,
      permissions: object.functions, // El backend espera 'permissions' no 'functions'
      spaces: selectedSpaces,
    }
    this.invitationService.sendInvitation(this.idCompany, payload).subscribe({
      next: (res) => {
        this.openInfoCard('Invitación enviada correctamente al usuario ' + object.user.email.toLowerCase());
      },
      error: (err) => {
        this.openInfoCard('Error al enviar la invitación al usuario ' + object.user.email.toLowerCase());
      }
    });
  }

  ngAfterViewInit() {
    this.usersManager = [];
    this.activatedRoute.queryParams.subscribe(params => {
      if (params.role) {
        this.searchText = '';
        this.sorted = null;
        this.roleActive = params.role == 'all' ? null : params.role;
      }
      this.getFilter();
    });
    this.searchTerms.pipe(
      debounceTime(300), // Espera 300ms después de cada pulsación de tecla
      distinctUntilChanged(), // Ignora si el nuevo término de búsqueda es igual al anterior
    ).subscribe(items => {
      this.searchText = items;
      this.getFilter();
    });
  }

  getData() {
    this.permissionService.getCompanyUsers(this.idCompany, this.searchText, this.roleActive).subscribe({
      next: (res) => {
        if (res && res.data) {
          // El nuevo endpoint no tiene paginación, así que marcar como finalizado
          this.finishScroll = true;
          this.usersManager = res.data;
          this.dataSource = new MatTableDataSource(this.usersManager);
          this.dataSource.sort = this.sort;
        }
        this.loadingPage = false;
        this.loadingTable = false;
        this.loadingScroll = false;
      },
      error: (err) => {
        this.loadingPage = false;
        this.loadingTable = false;
        this.loadingScroll = false;
      }
    });
  }

  getFilter() {
    this.usersManager = [];
    this.page = 1;
    this.finishScroll = false;
    this.loadingTable = true;
    this.getData();
  }

  searchUser(res: string) {
    this.searchTerms.next(res);
  }

  openUser(user: any) {
    if (user.active) {
      this.router.navigate(['/panel-control/config/permission/function/user', user.id_company_user || user.id]);
    }
  }

  getRolesUser(user: any) {
    // Nueva estructura: user.functions[]
    if (!user.functions || user.functions.length === 0) {
      return '';
    }

    // Obtener todos los roles únicos de todos los espacios
    const allRoles = new Set<string>();
    user.functions.forEach((funcion_name: string) => {
      allRoles.add(funcion_name);
    });

    return Array.from(allRoles).join(', ');
  }

  getPlacesUser(user: any) {
    // Nueva estructura: user.spaces[]
    if (!user.spaces || user.spaces.length === 0) {
      return '';
    }

    const spacesString = user.spaces.map((space: any) => space.space_name).join(', ');
    return spacesString;
  }

  getUserInitial(user: any): string {
    const name = user.name || user.nombre || user.email || '?';
    return name.charAt(0).toUpperCase();
  }

  // Sort
  sortData(sort: Sort) {
    const isAsc = (sort.direction === 'asc') ? 'asc' : 'desc';
    if (sort.direction) {
      this.sorted = { sortedBy: sort.active, sort: isAsc };
    } else {
      this.sorted = null;
    }
    this.getFilter();
  }

  openSendInvite(user: any) {
    // Solo permitir reenviar invitación si la fecha de actualización no es mayor a 2 horas
    this.invitationService.resendInvitation(this.idCompany, user.id_company_user).subscribe({
      next: (res) => {
        if (res) {
          //  Dialog informativo
          this.openInfoCard('Se ha enviado la invitación al usuario ' + user.email.toLowerCase());
        }
      },
      error: (err) => {
        this.openInfoCard('Error al enviar la invitación al usuario ' + user.email.toLowerCase());
      }
    });
  }

  deleteUser(users: any[]) {
    let userDeleted = users.map((value) => value.id);
    this.permissionService.deleteUsersPermission(this.idCompany, userDeleted).subscribe({
      next: (res) => {
        if (res) {
          //  Dialog informativo
          this.openInfoCard('El usuario ha sido eliminado correctamente');
        }
      },
      error: (err) => {
        this.openInfoCard('Error al eliminar el usuario');
      }
    });
  }

  openInfoCard(msg: string, disabledClose: boolean = false) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: ['info-dialog'],
      disableClose: disabledClose,
      data: {
        text: msg
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getFilter();
    });
  }

  //Pagination
  @HostListener('window:scroll', ['$event'])
  @HostListener('scroll', ['$event'])
  public isScrolledInfinityView(event) {
    if (!this.loadingTable) {
      if (!this.finishScroll) {
        const element = this.containerScroll.nativeElement.getBoundingClientRect();
        let bottomShown = element.bottom <= window.innerHeight;
        if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
          bottomShown = true;
        }
        if (bottomShown && !this.finishScroll) {
          this.page++;
          this.loadingScroll = true;
          setTimeout(() => {
            this.getData();
          }, 200);
        }
      } else {
        this.finishScroll = true;
      }
    }
  }

  containsBlocked() {
    return this.selectedItems.filter((item) => item.status == 'blocked').length <= 0;
  }

  activeSelecting() {
    this.activeSelectList = !this.activeSelectList;
    // Eliminar la seleccion actual
  }

  selectAll() {
    this.dataSource.data.forEach((item) => item.selected = this.allSelected);
    this.selectedItems = this.dataSource.data.filter((item) => item.selected);
  }

  changeSelectItem(item: any) {
    item.selected = !item.selected;
    this.selectedItems = this.dataSource.data.filter((item) => item.selected);
    this.allSelected = this.selectedItems.length === this.dataSource.data.length;
  }

}
